import { defineComponent as _defineComponent } from 'vue'
import TextTruncatedChip from '@/components/TextTruncatedChip.vue';
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
} from 'vue';
import sharedMessages from '@/lib/shared-messages';
import { StateItem } from '@/interfaces/lib/model';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectInTextField',
  props: {
    label: null,
    placeholder: null,
    textFieldPlaceholder: null,
    noDataText: null,
    options: null,
    selectedValues: null,
    isChipItemLabelType: { type: Boolean },
    chipColorHandler: null,
    disableItemHandler: null,
    noneOptionLabel: null,
    isNoneSelected: { type: Boolean }
  },
  emits: ["onChange", "updateIncludeNone"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onChange', value: string[] | number[]): void;
  (e: 'updateIncludeNone', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  label?: string;
  placeholder?: string;
  textFieldPlaceholder?: string;
  noDataText?: string;
  options: StateItem[];
  selectedValues: string[] | number[];
  isChipItemLabelType?: boolean;
  chipColorHandler?: (item: StateItem) => string;
  disableItemHandler?: (item: StateItem) => boolean;
  noneOptionLabel?: string;
  isNoneSelected?: boolean;
};



const searchKeyword = ref<string>('');

const chipAreaRef = ref<HTMLDivElement | null>(null);
const resizeObserver = ref<ResizeObserver | null>(null);
const truncateMaxLength = ref<number | undefined>(undefined);



const toggleNoneOption = () => {
  emits('updateIncludeNone', !props.isNoneSelected);
};

const filteredOptions = computed(() =>
  props.options.filter((item) =>
    item.title.toLowerCase().includes(searchKeyword.value.toLowerCase())
  )
);

const selectedItems = computed(() => {
  return props.selectedValues
    .map((v: string | number) =>
      props.options.find((option) => v === option.value)
    )
    .filter((v) => v !== undefined);
});

const handleDeleteClick = (value: string | number) => {
  // NOTES: expected string[] | number[] type but filter method returns (string | number)[] type so cast it
  const newValue = props.selectedValues.filter((v) => v !== value) as
    | string[]
    | number[];
  emits('onChange', newValue);
};

onMounted(() => {
  if (chipAreaRef.value) {
    resizeObserver.value = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        const coef = width < 250 ? 2 : 1;
        truncateMaxLength.value = Math.trunc(width / (15 * coef)); // NOTE: 150pxより小さくなるにつれてレイアウトが崩れ始める
      }
    });
    resizeObserver.value.observe(chipAreaRef.value);
  }
});

onUnmounted(() => {
  if (resizeObserver.value) {
    resizeObserver.value.disconnect();
  }
});

return { __sfc: true,props, searchKeyword, chipAreaRef, resizeObserver, truncateMaxLength, emits, toggleNoneOption, filteredOptions, selectedItems, handleDeleteClick, TextTruncatedChip, sharedMessages }
}

})